import { Container, i18n, Table, TableRow, TimeSpecificFilters, utils, http } from "@common";
import { useRef, useCallback, useEffect, useState } from 'react';
import { AuditLogsStatusOptions, DateRangeFilter, AuditLogRoleTypeOptions } from "../../constant";
import { adminService } from "@api";

const Auditlogs = () => {
    const tableRef = useRef();
    const [tableTotalItemsCount, setTableTotalItemsCount] = useState(0);

    useEffect(() => {
        const tableMaxNumbers = 1000000;
        if (tableTotalItemsCount >= tableMaxNumbers) {
            $$.toast(i18n.get('CIS_Admin_Common_dataTable_checkNo_Message'), 'warning');
        }
    }, [tableTotalItemsCount]);

    const filter = {
        items: [
            {
                id: 'filter-audit-logs-date-range',
                field: 'DateRange',
                title: i18n.get('CIS_Admin_Common_DateRange_Entry'),
                component: TimeSpecificFilters
            },
            {
                id: 'filter-audit-logs-status',
                field: 'Status',
                title: i18n.get('CIS_Admin_Common_Status_Entry'),
                items: AuditLogsStatusOptions
            }
            /*{
                id: 'filter-audit-logs-role',
                field: 'Role',
                title: i18n.get('CIS_Admin_Reporting_AuditLogs_Role_Entry'),
                items: AuditLogRoleTypeOptions
            }*/
        ],
        params: { DateRange: DateRangeFilter.Last7days },
        search: { id: 'search-audit-logs', placeholder: i18n.get('CIS_Admin_Reporting_AuditLogs_Search_Entry') },
    };

    const doDownload = useCallback(() => {
        $$.loading(true);
        const exportInfo = tableRef.current.getExportInfo();
        exportInfo['timeZone'] = new Date().getTimezoneOffset() / -60;
        exportInfo.pageIndex = 0;
        exportInfo.pageSize = 0;
        // exportInfo.filter = JSON.stringify(exportInfo.filter)
        adminService.testAuditLogsDownload({"json":JSON.stringify(exportInfo)}).then(() => {
            return true;
        }).catch((e) => {
            if (e?.errorCode === http.ErrorCode.CatchErrorCode) {
                $$.loading(false);
                $$.toast(e?.message, 'warning');
            }
        }).finally(() => {
            $$.loading(false);
        });
    }, []);

    const buttons = [
        {
            id: "btn-audit-logs-download",
            text: i18n.get('CIS_Admin_Common_Download_Entry'),
            classify: 'info',
            onClick: () => doDownload()
        },
    ];

    const columns = [
        { header: i18n.get('CIS_Admin_Reporting_AuditLogs_OccurredTime_Entry'), sortable: -1, valuePath: 'OccurredTime' },
        { header: i18n.get('CIS_Admin_Reporting_AuditLogs_UPN_Entry') },
        { header: i18n.get('CIS_Admin_Reporting_AuditLogs_Service_Entry'), sortable: true, valuePath: 'Service' },
        { header: i18n.get('CIS_Admin_Reporting_AuditLogs_Category_Entry'), sortable: true, valuePath: 'Category', width: [180] },
        { header: i18n.get('CIS_Admin_Reporting_AuditLogs_Activity_Entry'), sortable: true, valuePath: 'Activity' },
        { header: i18n.get('CIS_Admin_Reporting_AuditLogs_Status_Entry') },
        { header: i18n.get('CIS_Admin_Reporting_AuditLogs_StatusReason_Entry') },
        { header: i18n.get('CIS_Admin_Reporting_AuditLogs_Target_Entry') },
        { header: i18n.get('CIS_Admin_Reporting_AuditLogs_ActionBy_Entry') },
        //{ header: i18n.get('CIS_Admin_Reporting_AuditLogs_Role_Entry') },
    ];

    const onLoadData = useCallback(async (info) => {
        info['timeZone'] = new Date().getTimezoneOffset() / -60;
        const result = await adminService.auditLogsPaging(info).catch((e) => {
            if (e?.errorCode === http.ErrorCode.CatchErrorCode) {
                $$.loading(false);
                $$.toast(e?.message, 'warning');
            }
        });
        setTableTotalItemsCount(result?.totalItemsCount);
        return new Promise((resolve) => {
            resolve(result);
        });
    }, []);

    return (
        <Container>
            <Table
                id="table-audit-logs"
                ref={tableRef}
                onLoadData={onLoadData}
                rowTemplate={TableRowTemp}
                columns={columns}
                buttons={buttons}
                filter={filter}
                sort={{ name: 'OccurredTime', status: 'desc' }}
            />
        </Container>
    );
};
class TableRowTemp extends TableRow {
    render(Row, Cell) {
        /*const { occurredTime, service, category, activity, status, reason, target, actionBy, upn, role } = this.props.rowData;*/
        const { occurredTime, service, category, activity, status, reason, target, actionBy, upn } = this.props.rowData;
        return (
            <Row action={this.action}>
                <Cell>{utils.formatDateTime(occurredTime, true, true)}</Cell>
                <Cell>{upn}</Cell>
                <Cell>{service || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{category || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{activity || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{status || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{reason || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{target || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{actionBy || i18n.get('Common_NA_Entry')}</Cell>
                {/*<Cell>{role}</Cell>*/}
            </ Row>
        );
    }
}

export default Auditlogs;
